import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequestFailure, apiRequestStart, apiRequestSuccess, deleteParticelle, getCertificazioni, getCultura, getVarieta, setParticelle, setSingleParticelle } from "./particelleSlice";
import ParticelleApi from "../../services/ParticelleApi";
import { toast } from "react-toastify";
import { updateProdotto } from "../Prodotti/prodottiSlice";

// Fetch all sensori
export const fetchParticelle = createAsyncThunk(
    "particelle/fetchParticelle",
    async (_, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await ParticelleApi.getAllParticelle();
            dispatch(setParticelle(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to fetch particelle.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);
export const fetchCultura = createAsyncThunk(
    "particelle/fetchCultura",
    async (_, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await ParticelleApi.getcultura();
            dispatch(getCultura(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to fetch particelle.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);
export const fetchVarieta = createAsyncThunk(
    "particelle/fetchVarieta",
    async (_, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await ParticelleApi.getvarieta();
            dispatch(getVarieta(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to fetch Varieta.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);
export const fetchCertificazioni = createAsyncThunk(
    "particelle/fetchCertificazioni",
    async (_, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await ParticelleApi.getcertificazioni();
            dispatch(getCertificazioni(response.data.data));
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to fetch Varieta.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);


export const createParticelle = createAsyncThunk(
    "particelle/createParticelle",
    async (payload, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await ParticelleApi.createParticelle(payload);
            toast.success(response?.data?.message)
            dispatch(apiRequestSuccess());
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to create sensore.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);
export const deleteParticelleByID = createAsyncThunk(
    "particelle/deleteParticelle",
    async (id, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            let res = await ParticelleApi.deleteParticelle(id);
            toast.success(res?.data?.message)
            dispatch(deleteParticelle(id));
            dispatch(apiRequestSuccess());
            return id;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to delete sensore.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);



// Fetch single stabilimento
export const fetchSingleParticelle = createAsyncThunk(
    "particelle/fetchSingleParticelle",
    async (sensoreId, { dispatch }) => {
        dispatch(apiRequestStart());
        try {
            const response = await ParticelleApi.getParticelle(sensoreId);  // Make the API call
            dispatch(setSingleParticelle(response.data.data));  // Dispatch action to set the sensore data
            dispatch(apiRequestSuccess());  // Dispatch API request success
            return response.data;  // Return the fetched data
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to fetch sensore.";  // Handle error
            dispatch(apiRequestFailure(errorMessage));  // Dispatch API request failure
            throw new Error(errorMessage);  // Throw error for further handling
        }
    }
);
// // Create new sensore

// // Update sensore
export const updateParticelle = createAsyncThunk(
    "particelle/updateParticelle",
    async ({ id, data }, { dispatch }) => {
        // console.log(id, data, "123445")
        dispatch(apiRequestStart());
        try {
            const response = await ParticelleApi.updateParticelle(id, data);
            // console.log(response, "responsetesr")
            toast.success(response?.data?.message)
            dispatch(updateProdotto(response.data.data));
            dispatch(apiRequestSuccess());
            dispatch(fetchParticelle())
            return response.data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || "Failed to update sensore.";
            dispatch(apiRequestFailure(errorMessage));
            throw new Error(errorMessage);
        }
    }
);
// // Delete sensore
